import React from 'react';
import { cn } from '../../utils/cn';

export function FloatingInput({ label, type = "text", value, onChange, required, className, ...props }) {
  return (
    <div className={cn("relative z-0 w-full mb-5 group", className)}>
      <input 
        type={type} 
        value={value} 
        onChange={onChange} 
        required={required} 
        placeholder=" " 
        className="block py-3 px-0 w-full text-sm md:text-base text-white bg-transparent border-0 border-b-2 border-white/20 appearance-none focus:outline-none focus:ring-0 focus:border-brand-blue peer transition-colors"
        {...props} 
      />
      <label 
        className={cn(
          "peer-focus:font-medium absolute text-gray-400 text-xs md:text-sm duration-300 transform -translate-y-7 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-brand-blue peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-7",
          // Force label up if there is a value (important for masked inputs)
          value ? "scale-75 -translate-y-7" : ""
        )}
      >
        {label} {required && <span className="text-red-500">*</span>}
      </label>
    </div>
  );
}